import classNames from 'classnames';
import React from 'react';
import ReactSelect from 'react-select/async';
import InputLabel from '../InputLabel';
import './styles.css';

const AsyncSelect = ({
  label,
  labelClassName,
  help,
  showHelpTooltip = true,
  ...props
}) => {
  return (
    <div className={'select'}>
      <InputLabel
        className={labelClassName}
        label={label}
        help={help}
        showHelpTooltip={showHelpTooltip}
      >
        <ReactSelect
          classNames={{
            control: (state) => {
              return classNames(
                'select__control',
                {
                  'select__control--focused': state.isFocused,
                }
              );
            },
            option: (state) => {
              return classNames(
                'select__option',
                {
                  'select__option--selected': state.isSelected,
                  'select__option--focused': state.isFocused,
                }
              );
            },
            loadingIndicator: () => 'select__loading',
            input: () => 'select__input',
            singleValue: () => 'select__single-value',
          }}
          {...props}
        />
      </InputLabel>
    </div>
  );
};

export default AsyncSelect;
